export var version = "3.8.8";
//# sourceMappingURL=version.js.map